import {useCallback, useEffect, useState} from 'react'

const useVideoControl = (init = false, videoRef) => {
    const [isPlaying, setIsPlaying] = useState(init)

    const onVideoToggle = useCallback(() => {
        setIsPlaying((prev) => !prev)
    }, [])

    useEffect(() => {
        if (!videoRef?.current) return
        if (isPlaying) {
            videoRef.current.play()
        } else {
            videoRef.current.pause()
        }
    }, [isPlaying, videoRef])

    return [isPlaying, onVideoToggle]
}

export default useVideoControl
